import React from 'react';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrickWall, ElectricalEnergy, PaintRoller, Plumbing } from '../../assets/images';
import { PhonelinkLockOutlined } from '@mui/icons-material';


AOS.init();

// Reusable Button Component
const ContactButton: React.FC = () => {
  const sendMessage = () => {
    const message = encodeURIComponent("مرحبا، أرغب في معرفة المزيد عن خدمات التشطيب.");
    const whatsappUrl = `https://wa.me/201003234531?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
    className="bg-[#BAAD87] text-white py-3 px-8 rounded-full hover:bg-[#9E9195] transition-colors duration-300 flex items-center justify-center"
    onClick={sendMessage}
  >
    <PhonelinkLockOutlined className="mr-2" /> اتصل بنا للحصول على المزيد من التفاصيل
  </button>
  );
};

// Service Section Component
const ServiceSection: React.FC<{ title: string; icon: string; items: string[] }> = ({ title, icon, items }) => (
  <div className="mt-6 max-w-[370px] ">
    <h3 className="text-3xl text-right font-medium text-[#9E9195] flex items-center mt-6 ">
      <img src={icon} alt={`${title} Icon`} className="mr-2 w-24 h-24 ml-3 " />
      <span className="mr-2 text-4xl ">{title}</span>
    </h3>
    <ul className="list-disc list-inside text-right text-lg text-[#9E9195] gap-2 flex flex-col">
      {items.map((item, index) => (
        <li key={index} className=''><h4 className='mr-4 -mt-7' >{item}</h4></li>
      ))}
    </ul>
  </div>
);

// Package Component
const Package: React.FC<{ title: string; services: { title: string; icon: string; items: string[] }[] }> = ({ title, services }) => (
  <div className="bg-white rounded-lg p-6 mb-10  duration-300 lg:min-w-[400px]" data-aos="fade-up">
    <h2 className="text-4xl font-semibold text-[#BAAD87] text-right flex items-top gap-2">
      <span className="w-1/12 border-t-2 mt-10 border-primary"></span> <span>{title}</span>
    </h2>
    <div className='flex  gap-5 flex-wrap justify-between'>

    {services.map((service, index) => (
      <ServiceSection key={index} title={service.title} icon={service.icon} items={service.items} />
    ))}
    </div>
    <div className="mt-6 text-center">
      <ContactButton />
    </div>
  </div>
);

const PackageDetails: React.FC = () => (
  <>
    <Helmet>
      <title>اسعار باقة التشطيب في مصر</title>
      <meta
        name="description"
        content="تقدم شركة ديكور مصر العديد من انظمة التشطيب فى مصر من خلال تقديم اسعار باقة التشطيب 2023 تناسب جميع الفئات السعريه."
      />
    </Helmet>

    <div className="container mx-auto px-6 py-10">
      <h1 className="text-4xl font-extrabold mt-12 md:px-10  text-[#BAAD87] text-center mb-24 " data-aos="fade-up">
      تتميز شركتنا فى تقديم تقارير مفصله حول انفاق ميزانية التشطيب ومتابعه اسبوعيه بما تم تنفيذه 
      مع تقديم ضمان لمدة عامين على كافه اعمال التشطيب      </h1>
      <h1 className="text-4xl font-extrabold mb-6 text-[#BAAD87] text-right" data-aos="fade-up">
        بعض بنود باقات التشطيب
      </h1>

      <p className="text-lg text-right mb-10" data-aos="fade-up">
      تقدم الشركة العديد من انظمة التشطيب بافضل الاسعار والتى تناسب جميع العملاء باعلى معاير الجودة      </p>

      {/* Package Lux */}
      <Package
        title="باقة تشطيب لوكس"
        services={[
          {
            title: 'الكهرباء',
            icon: ElectricalEnergy,
            items: [
              'تأسيس جميع الاسلاك السويدي الأصلي ',
              'اسلاك 6 ملم للتكييفات والسخانات',
              'علب ماجيك وخراطيم علاء الدين الاصلي',
              'لوحة فينوس 12 خط او 24 خط حسب الجهد',
              'تأسيس وتركيب لوحة خدمات للراوتر والدش',
              'تأسيس الجبسن بورد اسلاك 2 ملم للأسبوتات',
              'تركيب ليد دوبل لبيت النور الداخلي ',
              'تركيب اوشاش صانش وفيش ومفاتيح كهرباء',
            ],
          },
          {
            title: 'السباكة',
            icon: Plumbing,
            items: [
              'مواسير مياه بي آر الماني ',
              'صرف لبلاعات البلكونات وتأسيس مخارج فلتر',
              'تركيب خلاطات ايديال استنادرد للحمامات',
              'تركيب احواض ديروفيت وقواعد ايديال ستاندرد',
            ],
          },
          {
            title: 'دهان وديكور',
            icon: PaintRoller,
            items: [
              'تجليخ الحوائط بحجر جلخ ',
              'دهان مادة سيلر مائى لتثبيت الاسطح',
              'سحب 4 طبقات معجون وواجهين بطانه ووجهين تشطيب',
            ],
          },
          {
            title: 'محارة وجبس',
            icon: BrickWall,
            items: [
              'محارة الموقع بالكامل علي الأداة ',
              'تركيب اسلاك فواصل بين الجدران',
              'دهارة اسقف الوحدة بالكامل بمادة كيمازيت من مواد البناء الحديث',
            ],
          },
        ]}
      />

      {/* Package Super Lux */}
      <Package
        title="باقة تشطيب سوبر لوكس"
        services={[
          {
            title: 'الكهرباء',
            icon: ElectricalEnergy,
            items: [
              'تأسيس جميع الاسلاك السويدي الأصلي ',
              'اسلاك 6 ملم للتكييفات والسخانات',
              'علب ماجيك وخراطيم علاء الدين الاصلي',
              'لوحة فينوس 24 خط',
              'تأسيس وتركيب لوحة خدمات للراوتر والدش',
            ],
          },
          {
            title: 'السباكة',
            icon: Plumbing,
            items: [
              'مواسير مياه اكوا ثيرم ',
              'صرف لبلاعات البلكونات وتأسيس مخارج فلتر',
              'تركيب خلاطات ايديال استنادرد للحمامات',
            ],
          },
          {
            title: 'دهان وديكور',
            icon: PaintRoller,
            items: [
              'تجليخ الحوائط بحجر جلخ ',
              'دهان مادة سيلر مائى لتثبيت الاسطح',
              'سحب 4 طبقات معجون وواجهين بطانه ووجهين تشطيب',
            ],
          },
        ]}
      />

      {/* Package Ultra Lux */}
      <Package
        title="باقة تشطيب ألترا لوكس"
        services={[
          {
            title: 'الكهرباء',
            icon: ElectricalEnergy,
            items: [
              'تأسيس جميع الاسلاك السويدي الأصلي ',
              'اسلاك 6 ملم للتكييفات والسخانات',
              'علب ماجيك وخراطيم علاء الدين الاصلي',
              'لوحة فينوس 32 خط',
              'تأسيس وتركيب لوحة خدمات للراوتر والدش',
              'تأسيس الجبسن بورد اسلاك 2 ملم للأسبوتات',
            ],
          },
          {
            title: 'السباكة',
            icon: Plumbing,
            items: [
              'مواسير مياه اكوا ثيرم ',
              'صرف لبلاعات البلكونات وتأسيس مخارج فلتر',
              'تركيب خلاطات ايديال استنادرد للحمامات',
              'تركيب احواض ديروفيت وقواعد ايديال ستاندرد',
            ],
          },
          {
            title: 'دهان وديكور',
            icon: PaintRoller,
            items: [
              'تجليخ الحوائط بحجر جلخ ',
              'دهان مادة سيلر مائى لتثبيت الاسطح',
              'سحب 5 طبقات معجون وواجهين بطانه ووجهين تشطيب',
            ],
          },
          {
            title: 'محارة وجبس',
            icon: BrickWall,
            items: [
              'محارة الموقع بالكامل علي الأداة ',
              'تركيب اسلاك فواصل بين الجدران',
              'دهان أسقف بكيمازيت',
              'تركيب كرانيش جبسية للأسقف',
            ],
          },
        ]}
      />
    </div>
  </>
);





export default PackageDetails;
